import React,{useState,}from 'react'
import { Modal, Form, Input, Button, App } from 'antd';
import { useClientTypeAddMutation,  } from '../../store/ReactWebSiteApi';

function ClientTypeAdd() {
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateClient = (values) => {
        // console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState();
    const [submitAdd] = useClientTypeAddMutation()
    console.log(info);
    return (
        <>
            <Button type='primary'  onClick={() => {setOpen(true);}}>新增客户类型</Button>
            <Modal
                        open={open}
                        title='新增客户类型'
                        okText="提交"
                        cancelText="取消"
                        onCancel={() => {setOpen(false);}}
                        onOk={() => {
                            form
                                .validateFields()
                                .then((values) => {
                                    form.resetFields();
                                    onCreateClient(values);
                                })
                                .catch((info) => {
                                    // console.log('Validate Failed:', info);
                                });
                            submitAdd({
                                ect_name:info,
                                ect_e_id:localStorage.getItem('e_id'),
                                ect_uid:localStorage.getItem('eu_id'),
                                ect_uname:localStorage.getItem('eu_name'),
                            }).then((res) => {
                                // console.log(res);
                                if (res.data.Status === 'success') {
                                    message.success('新增成功！')  
                                    setOpen(false)                         
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('新增失败！'+res.data.Message)
                                }
                            })
                        }}
                    >
                        <Form
                            form={form}
                            layout="horizontal"
                            name="clientTypeAddForm"
                            initialValues={{modifier: 'public',}}
                            labelCol={{ span: 7 }}
                        >                            
                            <Form.Item 
                                name="name" 
                                label='客户类型' 
                                wrapperCol={{span:10}} 
                                required                                
                            >
                                <Input            
                                    onChange={(e) => {setInfo(e.target.value)}}
                                />
                            </Form.Item>
                        </Form>
                    </Modal>
        </>
    )
}

export default ClientTypeAdd